module.exports = __webpack_public_path__ + "static/img/010酒庄官网1.d3a38bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/010酒庄官网1.jpg
// module id = c6c5
// module chunks = 0